

import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { Cart } from '../dto/cart/cart'

@Injectable({ providedIn: 'root' })
export class CartService {
  constructor(private http: HttpClient) {
  }

  get(page: number, size: number, cartFilter: Cart, sortCol: string, sortDir: string ): Observable<any> {
    let  params = new HttpParams().append('page', page.toString()).append('size', size.toString())
    .append('sortCol', sortCol.toString()).append('sortDir', sortDir.toString())
    if(cartFilter) {
      Object.keys(cartFilter).forEach(item => {
        params = params.append(item.toString(), cartFilter[item]?.toString() || '')
      })
    }
    return this.http.get(environment.apiUrl + '/dashboard/cart', { params: params}).pipe(map(data => data));
  }

  getById(cart_id: string) : Observable<any> {
    return this.http.get(environment.apiUrl + '/dashboard/cart/'+cart_id).pipe(map(data => data));
  }
}
